export default "__VITE_ASSET__BW9aXuW9__"